import { Saga } from './workers';

export default Saga;



// WEBPACK FOOTER //
// ./src/redux/media/get-all/sagas.js